<template>
  <div class="wrapper">
    <label>{{ label }}</label>
    <input
      :type="type"
      :disabled="disabled"
      :value="value"
      @input="input"
      @blur="blur"
    />
    <p>{{ error }}</p>
  </div>
</template>

<style scoped>
  .wrapper > label {
    display: block;
    font-style: normal;
    font-weight: 600;
    color: var(--secondary-text-color);
  }

  .wrapper > input {
    width: 100%;
    box-sizing: border-box;
    margin: 10px 0 5px 0;
    padding: 10px;
    font-family: inherit;
    font-size: 1.3rem;
    color: inherit;
    background-color: var(--secondary-background-color);
    border: none;
    border-bottom: 2px solid var(--primary-color);
    border-radius: 3px;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
    outline: none;
    transition-property: margin, padding, border-color, border-bottom, box-shadow;
    transition-duration: 0.3s;
  }

  .wrapper > input:focus {
    border-color: var(--secondary-color);
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1), inset 0 0 2px var(--secondary-color);
  }

  .wrapper > input:disabled {
    margin: 0;
    padding: 0;
    border-bottom: none;
    box-shadow: none;
    cursor: text;
  }

  .wrapper > p {
    margin-top: 0;
    margin-bottom: 10px;
    color: var(--error-color);
  }

  .wrapper > p:empty::before {
    display: block;
    content: '\00a0';
  }
</style>

<script>
  export default {
    props: [
      'label',
      'type',
      'disabled',
      'value',
      'input',
      'blur',
      'error'
    ]
  }
</script>
